module.exports = __webpack_public_path__ + "img/money-icon.93359f9a.png";